import { Policy } from './Policy';

export enum PolicyTemplateStaticCategory {
    FAVORITES = 'favorites',
    CUSTOM = 'custom'
}

export const POLICY_TEMPLATE_STATIC_CATEGORY_TO_BACKGROUND_COLOR = {
    [PolicyTemplateStaticCategory.CUSTOM]:
        'conic-gradient(from 137.73deg at 50% 50%, #0B5B46 0deg, #7AE9CB 180deg, #00B283 360deg)'
};
    
export const DEFAULT_POLICY_TEMPLATE = 'applications';

export type PolicyTemplateDynamicCategory = string;

export type PolicyTemplateTypeId = string;

export enum Protocols {
    KERBEROS_NTLM = 'kerberos_ntlm',
    LDAP = 'ldap',
    KERBEROS = 'kerberos',
    NTLM = 'ntlm'
}

export type PolicyRelevantFields = Omit<Policy, 'id' | 'name'> & {
    policyName: string;
};

export type PolicyTemplateEditableFieldsNames =
    | 'protocol'
    | keyof Omit<
          PolicyRelevantFields,
          'ntlm_enabled' | 'kerberos_enabled' | 'ldap_enabled' | 'oidc_enabled' | 'radius_enabled' | 'okta_enabled'
      >;

export type PolicyTemplateDetails = Partial<PolicyRelevantFields> & {
    name: string;
    typeId: PolicyTemplateTypeId;
    isFavorite: boolean;
    description: string;
    descriptionSummary: string;
    disclaimer?: string;
    mfaNote?: string;
    editableFields: PolicyTemplateEditableFieldsNames[];
    supportedActions: Policy['action_type'][];
    supportedProtocols?: Protocols[];
    authTypes: string[];
    spns?: string[];
    risks?: string[];
    protocolEntitiesSelectionTooltip?: string;
    hideSpnChips?: boolean;
    usersAndGroupsTooltip?: string;
    sourceTooltip?: string;
    destinationTooltip?: string;
};

export interface PolicyTemplate extends PolicyTemplateDetails {
    id: string;
}

export type PolicyTemplatesCategory = {
    id: string;
    name: string;
};
